import { styled, IconButton as MuiIconButton } from "@mui/material";
import { Link } from "react-router";
import { ReactComponent as LogoIcon } from "../../../../assets/icons/uptain_logo.svg";
import { UptainLogoProps } from "./UptainLogo.props";

export const UptainLogo = styled((props: UptainLogoProps) => (
  <MuiIconButton component={Link} {...props}>
    <LogoIcon />
  </MuiIconButton>
))(
  ({
    theme: {
      palette: { custom }
    }
  }) => `
    color: ${custom.white.main};
  `
);
